import { useEffect, useState } from 'react';
import './Home.css';

const Home = () => {
  const [nameFade, setNameFade] = useState({
    fade: 'fade-out',
  });
  const [profFade, setProfFade] = useState({
    fade: 'fade-out',
  });

  useEffect(() => {
    const timeoutName = setInterval(() => {
      if (nameFade.fade === 'fade-out') {
        setNameFade({
          fade: 'fade-in',
        });
      }
    }, 0);
    const timeoutProf = setInterval(() => {
      if (profFade.fade === 'fade-out') {
        setProfFade({
          fade: 'fade-in',
        });
      }
    }, 1100);
    return () => clearInterval(timeoutName, timeoutProf);
  }, [nameFade, profFade]);

  return (
    <div className={`home-container `}>
      <h1 className={`${nameFade.fade}`}>
        MARIANO <span>PEDRINI</span>
      </h1>
      <div className={`home-container__desc ${profFade.fade}`}>
        <div className="home-container__line"></div>
        <h2>Full Stack Developer</h2>
        <div className="home-container__line"></div>
      </div>
    </div>
  );
};

export default Home;
